import React, { Component } from "react";
import NavTab from '../../../components/common/global_layout/navTab'
import { Container} from "reactstrap";

import httpClient from '../../../httpClient'
import Footer from "../../../components/common/global_layout/footer";
import AllerRetouPlan from "../../../components/common/Vols/allerRetouPlan";
import ReserveBtn from "../../../components/common/Vols/reserveBtn";
import PagePath from "../../../components/common/pagePath";
import openInNewTab from '../../../shared'
require('bootstrap')

class VolDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      volDetail: [],
      isLoading: true,
      route: [],
      origin: {},
      price:{}
    };
  }
  async componentDidMount() {
    const token = this.props.match.params.token
    const volDetail = await httpClient.getDetailVol(token)
    await this.setState({
      volDetail: volDetail.flights,
      route: volDetail.route,
      origin: volDetail.flights[0],
      price:volDetail.conversion,
      sp_fee:volDetail.sp_fee,
      real_price:volDetail.real_price,
      booking_token:volDetail.booking_token
    })
  }

  render() {
    const curr = this.state.price.currency
    const sp_fee = this.state.sp_fee
    const real_price = this.state.real_price

    const detail = this.state.volDetail
    var vOv = false,
        Aller = [],
        Retour = []

    const distination = this.state.route[1]
    Aller.push(this.state.origin)

    detail.map((itineraries, i) => {
      //if where are in the segment where arriveCode is the destination then all cities after are of the return vol
      if (itineraries.dst === distination) vOv = true;

      //if where are still on the going vol and still didnt arrive at destination push city as escale on the going vol
      if (itineraries.dst !== distination && !vOv) Aller.push(itineraries);
      
      else if (itineraries.dst !== distination && vOv)  Retour.push(itineraries);
    })

    const originCity = this.state.origin.dst_name
    const destinationCity = this.state.origin.src_name
    const rtrn = Retour.length > 0
    const srcLink = new URLSearchParams(this.props.location.search)
    const deepLink = srcLink.get('deepLink')
    const flightsId = srcLink.get('flightsId')
    const booking_token = srcLink.get('booking_token')

    var srcUrl = deepLink+'&'+'flightsId='+flightsId+'&'+'booking_token='+booking_token
    return (
      <>
        <Container>
          <NavTab display="none" />
          <PagePath
            pages={['Ghurfaty', 'Vols']}
          />
          <Container>

            <div className="d-flex flex-column  mt-md-4 col-12 row">
              <div className="d-flex">
                <h5 className="plane__txt px-2 mr-2"><img className="plane__icon" src="/imgs/vols/suggestion-icons/plane_icon.svg" alt="vol" /><span className="ml-2">Vol</span></h5>
                <h5 className="plane__txt type__vol__txt px-4">Aller {rtrn && '-'+ 'Retour'}</h5>
              </div>
              <div className="volDetails__badge d-flex align-items-center">
                <h3 className="volDetails__volName d-flex">Vol avec escale {originCity} - {destinationCity} </h3>

                <span><img className="volDetails__special" src="/imgs/vols/suggestion-icons/special__vol.svg" alt="" /></span>
              </div>
              <h5 className="volDetails__tempsTrajet mt-2 mb-4">Temps du Trajet : 54h20m</h5>

            </div>
            {/* <div className="row ">
              <div className="d-flex flex-column mt-3 col-12 col-lg-6 mb-3 mb-lg-0 justify-content-end  ">
                <ClientDetails />
              </div>
              <div className="d-flex flex-column col-12 col-lg-6 justify-content-end">
                <LBdescription />
              </div>
            </div> */}
            <div className="volDetails__plans mt-4  d-flex flex-column flex-lg-row justify-content-between mb-4">
              <div className="volDetails__aller d-flex mb-4 mb-lg-0">
                <AllerRetouPlan type="Aller" itineraries={Aller} />
              </div>
              {rtrn && <div className="volDetails__retour d-flex ">
                <AllerRetouPlan type="Retour" itineraries={Retour}/>
              </div>}
            </div>
            <div className="volActions mt-4 d-flex flex-column flex-md-row justify-content-between">
              <div className="volempty"></div>
              <div className="volfull">
                <div className="volActions__factureVol">
                  <div className="d-flex justify-content-between mb-2">
                    <span className="fraisvol__txt">Sous-total</span>
                    <span className="fraisvol__prix">{real_price} {curr}</span>
                  </div>
                  <div className="fraisvol d-flex justify-content-between mb-2">
                    <span className="fraisvol__txt">Frais de services</span>
                    <span className="fraisvol__prix">{sp_fee} {curr}</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span className="fraisvol__tot__txt">Total</span>
                    <span className="fraisvol__tot">{real_price+sp_fee} {curr}</span>
                  </div>
                </div>
                <div className="volActions__actionsVol d-flex flex-column mt-3 mb-4">
                  <ReserveBtn color="#009aa5" height="40px" content="Contacter l'annonceur" icon="/imgs/resrervationIcons/annoncer-contacts.svg" />
                  <button style={{backgroundColor:"#015573", height: "40px"}} className="reserveActions__btn">
                    <a onClick={() => openInNewTab(`${srcUrl}`)} >Reserver maintenant</a> 
                    <img className="reserveActions__icons" src="/imgs/resrervationIcons/reserverMaintenant.svg" alt="" />
                   </button>
                </div>
              </div>

            </div>
          </Container>
        </Container>
        <Footer />
      </>

    );
  }
}

export default VolDetails;